module.exports = __webpack_public_path__ + "static/media/49850025-m4g1wSgs.76256736.JPG";